module.exports = __webpack_public_path__ + "img/CN.c40591ea.svg";